import Loadable from 'react-loadable'

import Loader from '~/components/Loading/List'

export default Loadable({
  loader: () => import('./Router'),
  loading: Loader,
})
